import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { fetchProfileAction } from 'redux/action/profileAction';
import { getCompanies, getCompanyDetails } from 'redux/slice/companySlice';
import { AppDispatch } from 'redux/store';

// Public routes that do not require authentication.
// Any route NOT in this list will redirect to /login if no accessToken is present.
const publicPaths = [
	'/login',
	'/thankYou',
	'/reset-password',
	'/forgot-password',
	'/callback',
	'/sso-callback',
	'/launch-callback',
	'/disconnect-callback',
	'/install-app-from-quickbooks',
	'/unauthorized',
];

export const AuthLayout = () => {
	const dispatch = useDispatch<AppDispatch>();
	const navigate = useNavigate();

	const location = useLocation();

	const path = window.location.pathname;

	if (window?.top !== window?.self) {
		if (window?.top) {
			window.top.location = window.self.location;
		}
	}

	useEffect(() => {
		// if (localStorage.getItem('accessToken')) {
		if (
			(!localStorage.getItem('isLogin') ||
				localStorage.getItem('isLogin') === 'false') &&
			(!localStorage.getItem('isFromAppInstall') ||
				localStorage.getItem('isFromAppInstall') === 'false')
		) {

			dispatch(fetchProfileAction())
				.unwrap()
				.then((res) => {

					dispatch(getCompanies(res));
					dispatch(getCompanyDetails(localStorage.getItem('companyId') || ''));
				})
				.catch(() => {
					if (
						!(
							path === '/forgot-password' ||
							path === '/reset-password' ||
							path === '/sso-callback'
						)
					) {
						navigate('/');
					}
				});
		}
		// }
	}, []);

	useEffect(() => {
		const token = localStorage.getItem('accessToken');
		const outsetaLoginStart = localStorage.getItem('outsetaLoginStart');

		if (outsetaLoginStart) {
			navigate('/');
			localStorage.removeItem('outsetaLoginStart');
		} else if (!publicPaths.includes(location.pathname) && !token) {
			// Redirect to login for any protected route when no access token is present.
			// Previously this checked against a short allowlist of authorized paths,
			// which caused a blank page for routes not on the list (e.g. /expense-allocations).
			navigate('/login');
		}
	}, [location.pathname]);

	return <Outlet />;
};
